// React
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// GSAP
import gsap from 'gsap';

// Props du composant MissionTitle
interface MissionTitleProps {
    title: string;
    missionNumber: number;
}

// Composant pour afficher le card avec le titre d'une mission avec animation
const MissionTitle: React.FC<MissionTitleProps> = ({ title, missionNumber }) => {
    const navigate = useNavigate();
    // 1. Créer une référence pour l'élément DOM
    const el = useRef<HTMLDivElement>(null);

    const delayIndex = missionNumber - 1;

    useEffect(() => {
        if (el.current) {
            // 2. Définir l'état initial (depuis le bas, invisible)
            gsap.set(el.current, { opacity: 0, y: 50 });

            // 3. Animer vers l'état final (position normale, visible)
            gsap.to(el.current, {
                opacity: 1,
                y: 0,
                duration: 1,
                delay: 2 + delayIndex * 0.6,
                ease: 'power3.out',
            });
        }
    }, [delayIndex]);

    return (
        <div
            className='mission-title-container'
            ref={el}
        >
            <div className='mission-title-shadow'></div>
            <button
                className={`mission-title ${
                    missionNumber % 2 === 0 ? 'mission-title-pair' : 'mission-title-impair'
                }`}
                onClick={() => navigate('mission/' + missionNumber)}
            >
                <img
                    src={`./images/${missionNumber % 2 === 0 ? 'white' : 'blue'}-pin.png`}
                    alt='Mission Icon'
                    className='mission-pin'
                />
                <div className='mission-title-text'>
                    <div className='subtitle'>Mission {missionNumber}</div>
                    <h1>{title}</h1>
                </div>
            </button>
        </div>
    );
};

export default MissionTitle;
